<template>
  <ion-page>
        <ion-header :translucent="true">
      <ion-toolbar>
        <ion-title>Home</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <section v-if="isLoggedIn">
        <ion-card class="myCard">
            <ion-button expand="block" color="primary">{{ $t('searchtournament') }}</ion-button>
            <ion-searchbar :placeholder="$t('searchtournamentdesc')" @ionClear="findTournament('')" @input="findTournament($event.target.value)"></ion-searchbar>
            <ion-button v-if="tournamentsFound && tournamentsFound.scoringRecords.length > 0 && !UserData.readonly" expand="block" color="danger" @click="deleteTournament()">{{ $t('deleteAll') }}</ion-button>
              <ion-list v-if="tournamentsFound">
                  <ion-item><h3>{{ tournamentsFound.name }}</h3></ion-item>
                  <ion-item>{{ $t('searchresulttournament') }}</ion-item>

                  <ion-item>
                    <ion-label v-for="item in enabledColums" :key="item"><h3><strong>{{ $t(item) }}</strong></h3></ion-label>
                  </ion-item>

                  <ion-item v-for="(sr, i) in tournamentsFound.scoringRecords" :key="i">
                    <ion-label><h3>{{ i + 1 }}</h3></ion-label> 
                    <ion-label>{{ dayjs(sr.date).format('DD.MM.YYYY') }}</ion-label>
                    <ion-label>{{ sr.playerName }}</ion-label>
                    <ion-label>{{ sr.scoreDifferential }}</ion-label>
                  </ion-item>
              </ion-list>
        </ion-card>

      </section>
      <section v-else>
        {{ $t('pleaseLogin') }}
      </section>
    </ion-content>
  </ion-page>
</template>

<script>
import { toastController, modalController, IonTitle, IonButton, IonToolbar, IonHeader, 
IonMenuButton, IonButtons, IonGrid, IonImg, IonCol, IonRow, IonItemDivider, IonSearchbar, 
IonApp, IonContent, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonMenu, IonMenuToggle, 
IonNote, IonRouterOutlet, IonSplitPane, IonSelect, IonSelectOption, IonAvatar, IonFabList, 
IonFabButton, IonFab, IonCardContent, IonCardHeader, IonCardTitle, IonCard, IonPage, alertController, loadingController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { useMutation, useQuery, useResult} from '@vue/apollo-composable'
import findTournamentQueryFile from '../graphql/findTournament.query.gql'
import deleteTournamentMutationFile from '../graphql/deleteTournamentMutation.mutation.gql'
import Storage from "../plugins/storage.js";
import * as dayjs from 'dayjs';

export default defineComponent({
  name: 'Home',
  components: {
    IonApp, IonImg, IonAvatar, IonPage,
    IonContent, 
    IonIcon, 
    IonItem, 
    IonLabel, 
    IonList, 
    IonListHeader, 
    IonMenu, 
    IonMenuToggle, 
    IonNote, 
    IonRouterOutlet, 
    IonSplitPane,
    IonSearchbar,
    IonItemDivider,
    IonGrid, 
    IonCol, 
    IonRow,
    IonTitle, IonButton, IonToolbar, IonHeader, IonMenuButton, IonButtons, IonSelect, IonSelectOption,
    IonFabList, IonFabButton, IonFab, IonCardContent, IonCardHeader, IonCardTitle, IonCard
  },
  data() {
    return {
      recentsFound: [],
    }
  },
  setup() {
    const { refetch: findTournamentRefetch, result: findTournamentResult, query: findTournamentQuery } = useQuery(findTournamentQueryFile, null)
    const { mutate: deleteTournamentMutation } = useMutation(deleteTournamentMutationFile)

    const tournamentsFound = useResult(findTournamentResult, null, data => data.findTournament.tournament)

    const enabledColums = ['', 'date', 'name', 'scoreDifferential']
    const tournamentNumber = ''

    return {
      tournamentsFound, dayjs, findTournamentRefetch, enabledColums, tournamentNumber, deleteTournamentMutation
    }
  },
  computed: {
    UserData : function(){ return this.$store.getters.UserData},
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
  },
  methods: {
    async deleteTournament() {
      const alert = await alertController
        .create({
          header: 'Scoring Records löschen',
          message: '<strong>Möchten Sie alle Scoring Record Einträge für dieses Turnier löschen?</strong>',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
            },
            {
              text: 'Ok',
              handler: async () => {
                   const loading = await loadingController.create({
                      message: 'Einträge werden gelöscht ...',
                    });
                    await loading.present();

                    return this.deleteTournamentMutation({ tournamentNumber: this.tournamentNumber }).then(res => {
                      loading.dismiss()
                      this.findTournamentRefetch({ searchTerm: this.tournamentNumber})
                      return 
                    })
                    .catch(async err => {
                      loading.dismiss()
                      const alert = await alertController.create({
                        header: 'Turnier Löschen Fehler',
                        message: JSON.stringify(err),
                        buttons: [
                          {
                            text: 'Ok',
                          },
                          {
                            text: 'Copy Error to Clipboard',
                            handler: () => {
                              this.copyToClipboard(JSON.stringify(err))
                            },
                          },
                        ],
                    });

                    await alert.present();
                    })

              },
            },
          ],
        });
      return alert.present();
    },
    copyToClipboard(text) {
      Clipboard.write({string: text })
      Toast.show({
          text: `Copied ${text} to Clipboard`
        })
    },
    async findTournament(searchTerm) {
      if (searchTerm.length > 0) {
        this.tournamentNumber = searchTerm
        this.findTournamentRefetch({ searchTerm: searchTerm})
      }
    },
  },
});
</script>

<style scoped>

#chart {
  max-width: 650px;
  margin: 35px auto;
}
#container {
  text-align: center;
  
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  
  color: #8c8c8c;
  
  margin: 0;
}

#container a {
  text-decoration: none;
}

section {
  margin-top: 1em;
  margin-bottom: 2.5em;
}

section:not(.full-width),
.full-width > header {
  padding: 0 10px;
}
</style>

<style lang="scss">

img{
  width:100%;
  height:100%;
}

.myCard{
  position:relative;

}

.myOverlay{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 99;
    bottom: 0px;
    opacity: 1;
    background: transparent;
    color: black;

}

</style>